import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export function shortPrincipal(p: string) {
	if (p.length < 12) return p;
	return `${p.slice(0, 6)}…${p.slice(-4)}`;
}

export function formatUsd(n: number, digits = 2) {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
		maximumFractionDigits: digits,
	}).format(n);
}

export function formatNum(n: number, digits = 2) {
	return new Intl.NumberFormat("en-US", {
		maximumFractionDigits: digits,
	}).format(n);
}

/** Parse user amount strings; strip grouping commas/spaces. */
export function parseAmount(raw: string | number | null | undefined): number {
	if (typeof raw === "number") return Number.isFinite(raw) ? raw : 0;
	if (raw == null) return 0;
	const s = String(raw).trim().replace(/,/g, "").replace(/\s/g, "");
	if (!s || s === "." || s === "-") return 0;
	const n = Number(s);
	return Number.isFinite(n) ? n : 0;
}

/** Amount string safe for controlled inputs / sliders (no thousand separators). */
export function formatAmountPlain(n: number, digits = 2): string {
	if (!Number.isFinite(n)) return "0";
	const d = Math.max(0, Math.min(12, digits));
	// Trim trailing zeros after fixed, keep readability for small decimals
	const fixed = n.toFixed(d);
	if (d === 0) return fixed;
	return fixed.replace(/\.0+$/, "").replace(/(\.[0-9]*?)0+$/, "$1");
}
